export default function ImmobilierEmptyState() {
  return (
    <div className="empty-state" style={{ paddingTop: 48 }}>
      <div style={{ fontSize: 56, marginBottom: 16 }}>🏘️</div>
      <h2 style={{ margin: '0 0 8px', fontSize: 20, color: 'rgb(var(--rgb-ink) / 0.8)' }}>Scraping immobilier</h2>
      <p style={{ margin: '0 0 24px', color: 'rgb(var(--rgb-ink) / 0.35)', fontSize: 14, maxWidth: 400, textAlign: 'center', lineHeight: 1.6 }}>
        Renseignez vos critères (type de bien, localisation, prix, surface…) et lancez une recherche en temps réel sur les portails immobiliers.
      </p>
      <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap', justifyContent: 'center' }}>
        {['🏠 Appartements & Maisons', '🏢 Bureaux & Locaux', '🌱 Terrains', '💶 Filtres prix & surface'].map((label) => (
          <div key={label} style={{ fontSize: 12, color: 'rgb(var(--rgb-ink) / 0.25)', background: 'rgba(91, 92, 244,0.04)', border: '1px solid rgba(91, 92, 244,0.12)', padding: '6px 14px', borderRadius: 20 }}>
            {label}
          </div>
        ))}
      </div>
    </div>
  )
}
